import { render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Router, Route, Switch } from 'wouter-preact';
import { Providers, useSession } from './contexts.jsx';
import { AppShell } from './AppShell.jsx';
import { Toast } from './ui/Toast.jsx';
import { InstallHint } from './ui/InstallHint.jsx';
import { SignIn } from './screens/SignIn.jsx';
import { Home } from './screens/Home.jsx';
import { Search } from './screens/Search.jsx';
import { Scan } from './screens/Scan.jsx';
import { Family } from './screens/Family.jsx';
import { Handover } from './screens/Handover.jsx';
import { HandoverDone } from './screens/HandoverDone.jsx';
import { useRegisterSW } from 'virtual:pwa-register/preact';

function AppRoutes() {
  const session = useSession();
  if (!session?.token) return <SignIn />;
  return (
    <AppShell>
      {session?.token && <InstallHint />}
      <Switch>
        <Route path="/">
          <Home />
        </Route>
        <Route path="/search">
          <Search />
        </Route>
        <Route path="/scan">
          <Scan />
        </Route>
        <Route path="/family/:key">{(p) => <Family familyKey={decodeURIComponent(p.key)} />}</Route>
        <Route path="/handover/:key">
          {(p) => <Handover familyKey={decodeURIComponent(p.key)} />}
        </Route>
        <Route path="/done/:key">
          {(p) => <HandoverDone familyKey={decodeURIComponent(p.key)} />}
        </Route>
        <Route path="/admin/*?">{() => <AdminLazy />}</Route>
      </Switch>
    </AppShell>
  );
}

function AdminLazy() {
  const [C, setC] = useState(null);
  useEffect(() => {
    import('./screens/admin/Console.jsx').then((m) => setC(() => m.default));
  }, []);
  return C ? <C /> : <div>Loading admin…</div>;
}

function UpdateBanner() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });
  if (!needRefresh) return null;
  return (
    <div class="toast" style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
      New version available.
      <button class="btn" onClick={() => updateServiceWorker(true)}>
        Refresh
      </button>
      <button class="btn" onClick={() => setNeedRefresh(false)}>
        Later
      </button>
    </div>
  );
}

render(
  <Providers>
    <Router>
      <AppRoutes />
      <Toast />
      <UpdateBanner />
    </Router>
  </Providers>,
  document.getElementById('app'),
);
